import { P } from "orcs-design-system";
import { SOURCE_OF_TRUTH_MISSING_MESSAGE } from "./persistedMoveSource";

const SourceOfTruthMissing = () => (
  <P mb="0">{SOURCE_OF_TRUTH_MISSING_MESSAGE}</P>
);

export default SourceOfTruthMissing;
